import {Attributes, Card} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {
  WhatsAppConnectionResponseBody,
  WhatsAppConnectionVerificationResponseBody,
} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

interface WhatsAppConnectionStatusProps {
  connection: WhatsAppConnectionResponseBody;
}

const getVerificationLabel = (verification: WhatsAppConnectionVerificationResponseBody) =>
  verification.state === 'verified'
    ? i18n.t('page.settings.telephony.verificationPassed')
    : i18n.t('page.settings.whatsApp.connection.notVerified');

export function WhatsAppConnectionStatus(props: WhatsAppConnectionStatusProps) {
  const formatDateTime = useDateTimeFormatter();

  const configuredAt = props.connection.configuredAt;

  return (
    <Card title={i18n.t('page.settings.whatsApp.connection.connectedTitle')} variant="inlineGrey">
      <Attributes
        rows={[
          {
            label: i18n.t('general.labels.status'),
            value:
              props.connection.configurationState === 'disabled'
                ? i18n.t('page.settings.facebookCredentials.disabled')
                : i18n.t('page.myProfile.receivingMailbox.status.connected'),
          },
          {
            label: i18n.t('page.settings.whatsApp.phoneNumber'),
            value: props.connection.phoneNumberId,
          },
          {
            label: i18n.t('page.settings.whatsApp.wabaId'),
            value: props.connection.wabaId,
          },
          {
            label: i18n.t('page.settings.whatsApp.connection.configuredAt'),
            value: isNil(configuredAt)
              ? null
              : formatDateTime('dateTimeShort', parseDate(configuredAt)),
          },
          {
            label: i18n.t('page.settings.whatsApp.connection.sending'),
            value: getVerificationLabel(props.connection.sendingVerification),
          },
          {
            label: i18n.t('page.settings.whatsApp.connection.receiving'),
            value: getVerificationLabel(props.connection.receivingVerification),
          },
        ]}
      />
    </Card>
  );
}
